import { trans } from "@mongez/localization";
import { useLocation } from "@remix-run/react";
import { cn, createPortal } from "core/shared";
import { userAtom } from "core/user";
import { LogOutIcon } from "lucide-react";
import { BaseLink, Button, ChevronRight } from "~/design-system/components";
import { Portal } from "~/modules/shared/components";
import { myAccountSidebarLinks } from "../../data";
import { logoutPortal } from "./LogoutPortal";

export const myAccountSidebarPortal = createPortal("my-account-sidebar");

export function MyAccountSidebarPortal() {
  const user = userAtom.useValue();
  const location = useLocation();

  const activeClass =
    "bg-primary-default/10 text-primary-default border-black mx-auto w-[95%]";

  return (
    <Portal portal={myAccountSidebarPortal}>
      <div className="flex flex-col gap-4">
        <div className="rounded-2xl border bg-white p-2">
          {/* User Info */}
          <div className="bg-primary-default/5 flex items-center gap-4 rounded-2xl px-3 py-2">
            <div className="border-primary-default flex size-14 items-center justify-center rounded-full border bg-black text-white uppercase">
              {`${user.name?.charAt(0)}${user.name?.charAt(1)}`}
            </div>
            <div className="flex flex-col">
              <h3 className="text-xl font-bold">{user.name}</h3>
              <p className="text-lg font-medium text-[#737373]">{user.email}</p>
            </div>
          </div>
        </div>
        {/* User Menu */}
        <div className="rounded-2xl border bg-white p-2">
          <div className="bg-primary-default/5 flex flex-col gap-2 rounded-2xl p-2">
            {myAccountSidebarLinks.map((link) => (
              <BaseLink
                className={cn(
                  "group hover:text-primary-default hover:bg-primary-default/10 mx-auto flex w-full shrink-0 items-center gap-4 rounded-full border border-transparent p-2 text-lg font-semibold transition-all duration-300 hover:w-[95%] hover:border-black",
                  location.pathname.endsWith(link.route) && activeClass,
                )}
                key={link.label}
                to={link.route}
                onClick={myAccountSidebarPortal.close}
              >
                <span className="group-hover:text-primary-default flex size-12 items-center justify-center rounded-full border border-black bg-white transition-colors duration-300">
                  <link.icon className="size-6" />
                </span>
                {trans(link.label)}
                <ChevronRight className="size-6 ltr:ml-auto rtl:mr-auto" />
              </BaseLink>
            ))}
            <Button
              className={cn(
                "group hover:text-primary-default hover:bg-primary-default/10 mx-auto flex w-full shrink-0 items-center gap-4 rounded-full border border-transparent p-2 text-lg font-semibold transition-all duration-300 hover:w-[95%] hover:border-black",
              )}
              onClick={() => {
                logoutPortal.open();

                myAccountSidebarPortal.close();
              }}
            >
              <span className="group-hover:text-primary-default flex size-12 items-center justify-center rounded-full border border-black bg-white transition-colors duration-300">
                <LogOutIcon className="size-6" />
              </span>
              {trans("logout")}
              <ChevronRight className="size-6 ltr:ml-auto rtl:mr-auto" />
            </Button>
          </div>
        </div>
      </div>
    </Portal>
  );
}
